var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14 2H8C6.343 2 5 3.343 5 5v14c0 1.657 1.343 3 3 3h8c1.657 0 3-1.343 3-3V8l-5-6Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4c0 1.105.895 2 2 2h3",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 16.5,
    r: 3.25,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8 15.2v2.6c0 .25.27.41.49.28l2.25-1.3a.32.32 0 0 0 0-.56l-2.25-1.3a.32.32 0 0 0-.49.28Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallFileIcon);
export default __webpack_public_path__ + "static/media/smallFileIcon.e98620bd7521d6fe5e261911bcb4d0f9.svg";
export { ForwardRef as ReactComponent };